import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const defaultPosOrderDeliveryCost = "";
export const posOrderDeliveryCostAtom = atomWithStorage<string>(
  "defaultPosOrderDeliveryCost",
  defaultPosOrderDeliveryCost
);

export const usePosOrderDeliveryCost = () => {
  const atom = useAtom(posOrderDeliveryCostAtom);
  return atom;
};

export const useSetPosOrderDeliveryCost = () =>
  useSetAtom(posOrderDeliveryCostAtom);

export default usePosOrderDeliveryCost;
